var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [_vm._v("Neues Passwort festlegen")]),
    _vm._v(" "),
    _c("div", { attrs: { id: "enterdata" } }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { margin: "10px 0 20px 0", "max-width": "320px" } },
        [
          _vm.hash == null
            ? _c("div", { staticClass: "fontColor3 font0875" }, [
                _vm._v("Altes Passwort")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hash == null
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.oldPassword,
                    expression: "oldPassword"
                  }
                ],
                attrs: { type: "password", id: "oldPassword" },
                domProps: { value: _vm.oldPassword },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.oldPassword = $event.target.value
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fontColor3 font0875",
              staticStyle: { "margin-top": "20px" }
            },
            [_vm._v("Neues Passwort")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newPassword1,
                expression: "newPassword1"
              }
            ],
            attrs: { type: "password", id: "newPassword1" },
            domProps: { value: _vm.newPassword1 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newPassword1 = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fontColor3 font0875",
              staticStyle: { "margin-top": "20px" }
            },
            [_vm._v("Passwort wiederholen")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newPassword2,
                expression: "newPassword2"
              }
            ],
            attrs: { type: "password", id: "newPassword2" },
            domProps: { value: _vm.newPassword2 },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newPassword2 = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "20px" } }, [
            _c(
              "button",
              {
                staticClass:
                  "btn btn-primary btn-block btn-lg btn-lg-reset-font-size text-uppercase text-letter-spacing2 white-space-normal",
                on: { click: _vm.changePassword }
              },
              [_vm._v("Absenden")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(1)
    ]),
    _vm._v(" "),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "padding-bottom": "20px" } }, [
      _vm._v(
        "\n            Bitte gib unten dein neues, gewünschtes Passwort ein."
      ),
      _c("br"),
      _vm._v(
        " Sobald du es gespeichert hast, musst du dich neu einloggen.\n        "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "errorBox",
        staticStyle: { display: "none" },
        attrs: { id: "errorbox" }
      },
      [_c("p", [_vm._v("Bitte berichtige die markierten Felder")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { display: "none" }, attrs: { id: "goodbye" } },
      [
        _c("div", [
          _vm._v("Das Passwort wurde geändert, du kannst dich jetzt anmelden")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4da96620", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da96620","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChangePassword.vue
// module id = 478
// module chunks = 2